import Component from '../lib/Component'
import { slideDown, slideUp, slideStop } from 'slide-anim'
import isUnderBreakpoint from '../lib/isUnderBreakpoint'

export default class Accordion extends Component {
  constructor (elem, APP) {
    super(elem, APP)
    this.triggers = [...this.elem.querySelectorAll('.js-Accordion__trigger')]
    this.items = [...this.elem.querySelectorAll('.js-Accordion__item')]
  }

  toggleState (item) {
    slideStop(item.querySelector('.js-Accordion__content'))
    if (item.classList.contains('_is_expanded')) {
      this.closeAccordion(item)
    } else {
      this.openAccordion(item)
    }
  }

  closeAccordion (item) {
    item.classList.remove('_is_expanded')
    slideUp(item.querySelector('.js-Accordion__content'))
  }

  openAccordion (item) {
    item.classList.add('_is_expanded')
    slideDown(item.querySelector('.js-Accordion__content'))
  }

  closeAll () {
    for (let i = 0; i < this.items.length; i++) {
      this.closeAccordion(this.items[i])
    }
  }

  init () {
    window.addEventListener('resize', () => {
      if (!isUnderBreakpoint('tablet-landscape')) {
        this.closeAll()
      }
    })
    if (this.triggers) {
      this.triggers.forEach((trigger, index) => {
        trigger.addEventListener('click', e => {
          this.toggleState(this.items[index])
        })
      })
    }
  }
}
